import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL, IMAGE_URL } from '../Component/Baseurl';
import defaultImage from './img/event1.jfif';  
import ban1 from './img/ban2.jpg';  
import { Link } from 'react-router-dom'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

function FeaturedEvent() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/GetAllExhibitions`);

        // Log the API response to the console
        console.log('API Response:', response);

        if (response.data.exhibitions) {
          setEvents(response.data.exhibitions.slice(0, 8)); // Only fetch 8 events
        } else {
          setError('Failed to fetch exhibitions');
        }

        setLoading(false); // Stop the loader
      } catch (error) {
        console.error('Error fetching exhibitions:', error);
        setError('Error fetching exhibitions');
        setLoading(false); // Stop the loader
      }
    };

    fetchEvents();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="ms-3">Loading Content...</p>
      </div>
    );
  }

  if (error) return <p>{error}</p>;

  return (
    <>
      <section className="bg-light pt-3">
        <div className="">
          <div className="row g-1">
            <div className="col-8">
              <h2 className="text-start hedng mb-3">Featured Events</h2>
            </div>
            <div className="col-4 text-end">
              <Link to="/filter/country/India" className="text-end viewall">
                View All <FontAwesomeIcon icon={faArrowRight} />
              </Link>
            </div>
          </div>

          <div className="row g-4">
            {events.map((exhibition) => (
              <div key={exhibition.id} className="col-md-3 col-6">
                <Link to={`/exhibition/${exhibition.exhibition_slug}`} className="event-card-link">
                  <div className="event-card">
                    <img
                      src={exhibition.eventbanner ? `${IMAGE_URL}eventFiles/${exhibition.eventbanner}` : defaultImage} 
                      alt={exhibition.exhibition_name}
                      className="img-fluid eventimg"
                    />
                    <div className="event-details text-start p-1">
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <span className="badge bg-gradient-primary etype">
                          {exhibition.exhibition_frequency}
                        </span>
                        <span className="ft-tags">
                          {new Date(exhibition.exhibition_start_date).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'short',
                            year: '2-digit',
                          })}
                        </span>
                      </div>
                      <h4 className="ft-event">{exhibition.exhibition_name}</h4>
                      <div>
                        <span className="ft-tags">
                          {exhibition.organised_by}
                        </span>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-light">
        <div className="container">
          <div className="py-3">
            <img src={ban1} alt="" className="img-fluid w-100 mxhtimgban" />
          </div>
        </div>
      </section>
    </>
  );
}

export default FeaturedEvent;
